import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowseRegistriesDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 141,
	viewBox: "0 0 412 141",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M304 79C304 70.7157 297.284 64 289 64",
			stroke: "#F2B014",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0426 97.1726C43.8326 97.1826 43.6226 97.1327 43.4326 97.0027C42.9826 96.6927 42.8626 96.0826 43.1726 95.6326L48.9326 87.1926C49.1026 86.9426 49.3826 86.7826 49.6826 86.7626C49.9626 86.7326 50.2826 86.8627 50.4826 87.0827L54.2026 91.1726L60.8726 80.1326C61.0326 79.8726 61.2926 79.7026 61.5926 79.6626C61.8926 79.6326 62.1926 79.7326 62.4126 79.9426L66.4626 83.9727L75.0126 71.4326C75.3226 70.9826 75.9326 70.8626 76.3826 71.1726C76.8326 71.4826 76.9527 72.0926 76.6427 72.5426L67.4326 86.0626C67.2726 86.3026 67.0026 86.4627 66.7126 86.4927C66.4026 86.5327 66.1326 86.4127 65.9226 86.2127L61.9226 82.2327L55.2226 93.3327C55.0626 93.6027 54.7826 93.7726 54.4726 93.8026C54.1426 93.8426 53.8526 93.7127 53.6426 93.4827L49.8726 89.3427L44.8226 96.7527C44.6426 97.0127 44.3526 97.1626 44.0626 97.1826L44.0426 97.1726Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 31.4375,
			x2: 17.1012,
			y2: 46.4375,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 60.8112,
			y2: -.45,
			transform: "matrix(0.707107 0.707107 0.707107 -0.707107 95 34.999)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 55.999C13.4183 55.999 17 52.4173 17 47.999C17 43.5807 13.4183 39.999 8.99999 39.999C4.58171 39.999 1 43.5807 1 47.999C1 52.4173 4.58171 55.999 8.99999 55.999Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 50.999C10.6568 50.999 12 49.6559 12 47.999C12 46.3422 10.6568 44.999 8.99999 44.999C7.34313 44.999 6 46.3422 6 47.999C6 49.6559 7.34313 50.999 8.99999 50.999Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 37C94.4183 37 98 33.4183 98 29C98 24.5817 94.4183 21 90 21C85.5817 21 82 24.5817 82 29C82 33.4183 85.5817 37 90 37Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 32C91.6569 32 93 30.6569 93 29C93 27.3431 91.6569 26 90 26C88.3431 26 87 27.3431 87 29C87 30.6569 88.3431 32 90 32Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 129)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 63)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 126)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 55C336.418 55 340 58.5817 340 63C340 67.4183 336.418 71 332 71C327.582 71 324 67.4183 324 63C324 58.5817 327.582 55 332 55Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 60C333.657 60 335 61.3431 335 63C335 64.6569 333.657 66 332 66C330.343 66 329 64.6569 329 63C329 61.3431 330.343 60 332 60Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 63C407.418 63 411 66.5817 411 71C411 75.4183 407.418 79 403 79C398.582 79 395 75.4183 395 71C395 66.5817 398.582 63 403 63Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 68C404.657 68 406 69.3431 406 71C406 72.6569 404.657 74 403 74C401.343 74 400 72.6569 400 71C400 69.3431 401.343 68 403 68Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 124C296.418 124 300 127.582 300 132C300 136.418 296.418 140 292 140C287.582 140 284 136.418 284 132C284 127.582 287.582 124 292 124Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 129C293.657 129 295 130.343 295 132C295 133.657 293.657 135 292 135C290.343 135 289 133.657 289 132C289 130.343 290.343 129 292 129Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.2999 18.65C39.2999 20.67 37.6699 22.3 35.6499 22.3C33.6299 22.3 32 20.67 32 18.65C32 16.63 33.6299 15 35.6499 15C37.6699 15 39.2999 16.63 39.2999 18.65Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M351.3 100.65C351.3 102.67 349.67 104.3 347.65 104.3C345.63 104.3 344 102.67 344 100.65C344 98.63 345.63 97 347.65 97C349.67 97 351.3 98.63 351.3 100.65Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121 8C121 3.58172 124.582 0 129 0H283C287.419 0 291 3.58172 291 8V104C291 108.418 287.419 112 283 112H129C124.582 112 121 108.418 121 104V8Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 125,
			y: 4,
			width: 162,
			height: 93,
			rx: 4,
			fill: "#1C1C1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.15 104.2C209.15 105.971 207.715 107.4 205.95 107.4C204.185 107.4 202.75 105.965 202.75 104.2C202.75 102.435 204.185 101 205.95 101C207.715 101 209.15 102.435 209.15 104.2Z",
			stroke: "#9F9FA5",
			strokeWidth: .9,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.881 133C172.881 129.465 175.746 126.6 179.281 126.6H230.481C234.016 126.6 236.881 129.465 236.881 133H172.881Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 187.817,
			y: 111.667,
			width: 34.1333,
			height: 14.9333,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M208.267 118.4C203.574 115.413 192.8 114.667 188 114.667V112H222.134V126.933H220C218.045 125.333 212.96 121.387 208.267 118.4Z",
			fill: "#464649"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.881 8C124.881 5.79086 126.672 4 128.881 4H283.015C285.224 4 287.015 5.79086 287.015 8V21.0667H124.881V8Z",
			fill: "#131314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M260.546 12.6314C260.546 13.8657 259.549 14.8634 258.314 14.8634C257.08 14.8634 256.083 13.8657 256.083 12.6314C256.083 11.397 257.08 10.3994 258.314 10.3994C259.549 10.3994 260.546 11.397 260.546 12.6314Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M269.772 12.6314C269.772 13.8657 268.774 14.8634 267.54 14.8634C266.305 14.8634 265.308 13.8657 265.308 12.6314C265.308 11.397 266.305 10.3994 267.54 10.3994C268.774 10.3994 269.772 11.397 269.772 12.6314Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.586 12.6314C279.586 13.8657 278.588 14.8634 277.354 14.8634C276.12 14.8634 275.122 13.8657 275.122 12.6314C275.122 11.397 276.12 10.3994 277.354 10.3994C278.588 10.3994 279.586 11.397 279.586 12.6314Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.217 9.33301H136.878L136.797 9.33386C136.55 9.32948 136.461 9.42506 136.387 9.54309L135.335 11.1601L134.327 9.57561L134.294 9.52367C134.294 9.52367 134.266 9.47732 134.218 9.4756H134.218C134.169 9.47732 134.142 9.52367 134.142 9.52367L134.108 9.57561L133.135 11.1601L132.049 9.54309C131.975 9.42506 131.885 9.32948 131.638 9.33386L131.557 9.33301H130.218L130.218 10.6533H131.007C131.173 10.6517 131.25 10.6597 131.364 10.8017L131.411 10.8735L133.005 13.4588C133.005 13.4588 133.057 13.5423 133.144 13.5428C133.239 13.5431 133.292 13.4586 133.292 13.4586L134.219 12.0161H134.22L135.184 13.4567C135.184 13.4567 135.239 13.5421 135.321 13.5442C135.409 13.5465 135.457 13.4586 135.457 13.4586L137.026 10.8735L137.073 10.8017C137.154 10.6694 137.257 10.6555 137.423 10.6572L138.212 10.6566L138.217 9.33301Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.2 13.0031L135.343 14.4148L134.236 12.7516L133.386 14.079L135.182 16.9981C135.244 17.0788 135.293 17.0958 135.318 17.0966C135.373 17.0991 135.404 17.0689 135.463 16.9668L136.87 14.3013C136.995 14.0698 137.205 14.0728 137.205 14.0728H138.22L138.22 12.7542H136.633C136.345 12.7542 136.2 13.0031 136.2 13.0031Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 154.18,
			y: 35.5,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 181.916,
			y: 35.5,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 209.649,
			y: 35.5,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 237.38,
			y: 35.5,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 154.18,
			y: 60.0332,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 181.916,
			y: 60.0332,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 209.649,
			y: 60.0332,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 237.38,
			y: 60.0332,
			width: 20.3333,
			height: 11.8,
			rx: 2.5,
			stroke: "#464649"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 162.83,
			y1: 50.3831,
			x2: 157.33,
			y2: 50.3831,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 167.099,
			y1: 53.5833,
			x2: 157.332,
			y2: 53.5833,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 190.566,
			y1: 50.3831,
			x2: 185.066,
			y2: 50.3831,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 194.83,
			y1: 53.5833,
			x2: 185.064,
			y2: 53.5833,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 218.299,
			y1: 50.3831,
			x2: 212.799,
			y2: 50.3831,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 222.566,
			y1: 53.5833,
			x2: 212.799,
			y2: 53.5833,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 246.03,
			y1: 50.3831,
			x2: 240.53,
			y2: 50.3831,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 250.299,
			y1: 53.5833,
			x2: 240.532,
			y2: 53.5833,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 162.83,
			y1: 74.9168,
			x2: 157.33,
			y2: 74.9168,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 167.099,
			y1: 78.1165,
			x2: 157.332,
			y2: 78.1165,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 190.566,
			y1: 74.9168,
			x2: 185.066,
			y2: 74.9168,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 194.83,
			y1: 78.1165,
			x2: 185.064,
			y2: 78.1165,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 218.299,
			y1: 74.9168,
			x2: 212.799,
			y2: 74.9168,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 222.566,
			y1: 78.1165,
			x2: 212.799,
			y2: 78.1165,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 246.03,
			y1: 74.9168,
			x2: 240.53,
			y2: 74.9168,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 250.299,
			y1: 78.1165,
			x2: 240.532,
			y2: 78.1165,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.781 96.734C115.781 107.934 119.734 117.148 134.322 117.213",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.043 21.01C346.833 21 346.623 21.0499 346.433 21.1799C345.983 21.4899 345.863 22.1 346.173 22.55L351.933 30.99C352.103 31.24 352.383 31.4001 352.683 31.4201C352.963 31.4501 353.283 31.32 353.483 31.1L357.203 27.01L363.873 38.0501C364.033 38.3101 364.293 38.48 364.593 38.52C364.893 38.55 365.193 38.45 365.413 38.24L369.463 34.21L370.5 33.1826C370.628 32.9243 370.593 32.36 370.433 32.12C370.273 31.88 370.003 31.7199 369.713 31.6899C369.403 31.6499 369.133 31.77 368.923 31.97L364.923 35.95L358.223 24.85C358.063 24.58 357.783 24.41 357.473 24.38C357.143 24.34 356.853 24.47 356.643 24.7L352.873 28.84L347.823 21.4299C347.643 21.1699 347.353 21.02 347.063 21L347.043 21.01Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.15,
			cy: 78.6,
			r: 9.6,
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 292.407,
			y1: 78.9712,
			x2: 285.918,
			y2: 77.9677,
			stroke: "#2C2C2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 289.563,
			y1: 75.3357,
			x2: 288.56,
			y2: 81.8253,
			stroke: "#2C2C2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBrowseRegistriesDark);
export default ForwardRef;
